import Interval from '../functions/timers/interval';

export default {
  data() {
    return {
      now: Date.now(),
      timerList: [],
    };
  },
  mounted() {
    this.startInterval(() => { this.now = Date.now(); }, 32);
  },
  beforeDestroy() {
    this.timerList.forEach((t) => t.stop());
  },
  methods: {
    /**
     * Starts an interval that will be automatically
     * cleaned up when the component is destroyed
     * @param {Function} method The method you want to run. Will be bound to `this`
     * @param {Number} time The interval timeout period
     */
    startInterval(method, time = 1000) {
      this.timerList.push(Interval.begin(method.bind(this), time));
    },
  },
};
